// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityValues = {
  active: "有効",
  inactive: "無効",
  undefinedStatus: "未定義ステータス",
  yes: "はい",
  no: "いいえ",
  global: "グローバル",
  loginStatusSuccess: "成功",
  loginStatusFailed: "失敗",
  loginAuthFlowPassword: "パスワードログイン",
  loginAuthFlowOidcAuthorize: "OIDC 認可",
  eventActionCreate: "作成",
  eventActionUpdate: "更新",
  eventActionDelete: "削除",
  eventActionSync: "同期",
  eventActionArchive: "アーカイブ",
  eventActionInspect: "確認",
  eventActionRotate: "ローテーション",
  eventActionUpdateStatus: "状態を更新",
  eventActionResetPassword: "パスワードをリセット",
  eventActionKickout: "強制ログアウト",
  eventActionBatchKickout: "一括強制ログアウト",
  eventActionBatchUpdateStatus: "状態を一括更新",
  eventActionMove: "移動",
  eventActionSynced: "同期済み",
  eventTypePlatformRoleCreated: "プラットフォームロール作成",
  eventTypePlatformRoleUpdated: "プラットフォームロール更新",
  eventTypePermissionCreated: "権限点作成",
  eventTypePermissionUpdated: "権限点更新",
  eventTypePermissionBindingUpdated: "権限バインド更新",
  eventTypeUserCreated: "ユーザー作成",
  eventTypeUserUpdated: "ユーザー更新",
  eventTypeUserStatusUpdated: "ユーザー状態更新",
  eventTypeUserPasswordReset: "ユーザーパスワードリセット",
  eventTypeUserKickout: "ユーザー強制ログアウト",
  eventTypeUserBatchKickout: "ユーザー一括強制ログアウト",
  eventTypeUserBatchStatusUpdated: "ユーザー状態一括更新",
  eventTypeUserCustomFieldsUpdated: "ユーザーカスタム項目更新",
  eventTypeCustomFieldDefinitionCreated: "カスタム項目定義作成",
  eventTypeCustomFieldDefinitionUpdated: "カスタム項目定義更新",
  eventTypeCustomFieldDefinitionArchived: "カスタム項目定義アーカイブ",
  eventTypeTenantCreated: "テナント作成",
  eventTypeTenantUpdated: "テナント更新",
  eventTypeOrganizationCreated: "組織作成",
  eventTypeOrganizationUpdated: "組織更新",
  eventTypeOrganizationMembershipCreated: "組織メンバーシップ作成",
  eventTypeOrganizationMembershipDeleted: "組織メンバーシップ削除",
  eventTypeOrganizationUnitCreated: "組織ユニット作成",
  eventTypeOrganizationUnitUpdated: "組織ユニット更新",
  eventTypeOrganizationUnitDeleted: "組織ユニット削除",
  eventTypeOrganizationUnitMoved: "組織ユニット移動",
  eventTypeApplicationCreated: "アプリ作成",
  eventTypeApplicationUpdated: "アプリ更新",
  eventTypePlatformRoleAssignmentCreated: "プラットフォームロール割当作成",
  eventTypePlatformRoleAssignmentDeleted: "プラットフォームロール割当削除",
  eventTypeApplicationGrantCreated: "アプリ利用ルール作成",
  eventTypeApplicationGrantUpdated: "アプリ利用ルール更新",
  eventTypeApplicationGrantDeleted: "アプリ利用ルール削除",
  eventTypePermissionBindingCreated: "権限バインド作成",
  eventTypePermissionBindingDeleted: "権限バインド削除",
  eventTypeApplicationRoleMappingCreated: "アプリロールマッピング作成",
  eventTypeApplicationRoleMappingUpdated: "アプリロールマッピング更新",
  eventTypeApplicationRoleMappingDeleted: "アプリロールマッピング削除",
  eventTypeIdentityApplicationRoleCatalogSynced: "アプリロールディレクトリ同期済み",
  eventTypeApplicationMemberSnapshotSynced: "アプリメンバー要約同期済み",
  eventTypeApplicationCredentialInspected: "アプリ接続資格情報確認",
  eventTypePortalSettingsUpdated: "ポータル設定更新",
  eventTypeApplicationCredentialRotated: "アプリ接続資格情報ローテーション",
  eventTypeApplicationCredentialStatusUpdated: "アプリ接続資格情報状態更新",
  eventTypePortalGroupCreated: "ポータルグループ作成",
  eventTypePortalGroupUpdated: "ポータルグループ更新",
  eventTypePortalGroupDeleted: "ポータルグループ削除",
  eventResourceTypePortalSettings: "ポータル設定",
  eventResourceTypePlatformRole: "プラットフォームロール",
  eventResourceTypePermissionDefinition: "権限点定義",
  eventResourceTypePermissionBinding: "権限バインド",
  eventResourceTypeUser: "ユーザー",
  eventResourceTypeUserCustomFields: "ユーザーカスタム項目",
  eventResourceTypeIdentityCustomFieldDefinition: "ID カスタム項目定義",
  eventResourceTypeTenant: "テナント",
  eventResourceTypeOrganization: "組織",
  eventResourceTypeOrganizationMembership: "組織メンバーシップ",
  eventResourceTypeOrganizationUnit: "組織ユニット",
  eventResourceTypeApplication: "アプリ",
  eventResourceTypeApplicationGrant: "アプリ利用ルール",
  eventResourceTypeApplicationRoleMapping: "アプリロールマッピング",
  eventResourceTypeApplicationCredential: "アプリ接続資格情報",
  eventResourceTypeApplicationRoleCatalog: "アプリロールディレクトリ",
  eventResourceTypeApplicationMemberSnapshot: "アプリメンバー要約",
  eventResourceTypePlatformRoleAssignment: "プラットフォームロール割当",
  eventResourceTypePortalGroup: "ポータルグループ",
} as const;
